<div class="flex h-full flex-col overflow-hidden" data-cy="last-active-transfers">
	<section
		class="flex min-h-0 flex-1 flex-col rounded-2xl bg-gray-000 p-3"
		aria-labelledby="last-active-transfers-title">
		<!-- Title first and the badge second: the RTL reading order, which puts the
			count of requests still on their way just left of the title. Outside the
			scroller, so the title stays put over the rows. -->
		<div class="flex shrink-0 items-center gap-1.5 py-1" data-cy="last-active-transfers-header">
			<h2 id="last-active-transfers-title" class="text-3.25 font-bold text-gray-800">تراکنش‌های اخیر</h2>
			@if (pendingCount() > 0) {
				<ui-badge
					structure="number"
					tip="yellow"
					data-cy="last-active-transfers-pending-count"
					[border]="false"
					[value]="pendingCount()"
					[ariaLabel]="pendingCount() + ' تراکنش در حال انجام'" />
			}
		</div>

		<!-- Scroll anchoring is off: it would nudge `scrollTop` while the wallet page folds
			its balance card over this list, and the page reads that nudge as a scroll. -->
		<div
			#list
			class="min-h-0 flex-1 overflow-y-auto [overflow-anchor:none]"
			data-cy="last-active-transfers-list"
			(scroll)="scrolled.emit(list)">
			@if (loading()) {
				<div class="flex items-center justify-center p-3" data-cy="last-active-transfers-loading">
					<ui-loading />
				</div>
			} @else if (error()) {
				<ui-empty-state
					class="grow items-center p-3"
					variant="error"
					iconName="alert-box"
					title="خطایی رخ داد!"
					primaryButtonLabel="تلاش مجدد"
					[showDescription]="false"
					[showButton]="true"
					(primaryClicked)="load()" />
			} @else if (!requests().length) {
				<ui-empty-state
					class="grow items-center p-3"
					variant="empty"
					iconName="alert-box"
					description=""
					title="هیچ تراکنشی برای امروز وجود ندارد" />
			} @else {
				@for (request of requests(); track request.id) {
					<app-wallet-transfer-row
						class="min-h-17 border-b border-stroke-050 py-2.5 last:border-b-0"
						[attr.data-cy]="'wallet-transfer-' + request.id"
						[request]="request"
						(selected)="openDetails(request)" />
				}
			}
		</div>
	</section>
	<app-wallet-transfer-detail-bottom-sheet #detailSheet [request]="selectedRequest()" (closed)="onDetailsClosed()" />
</div>
